




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SitePermission } from '@/models/site-permission';
import { CreateUserRequest } from '@/models/create-user-request';

@Component
export default class CreateUserModal extends Vue {
    @Prop({ required: true, type: Boolean }) public show: boolean;
    public showing: boolean = this.show;
    public selectedTab: number = 0;
    public email: string | null = null;
    public password: string | null = null;
    public firstName: string | null = null;
    public lastName: string | null = null;
    public permissions: Array<{ id: string, name: string, selected: boolean }> = [];

    public Save(): void {
        const user: CreateUserRequest = {
            email: this.email,
            password: this.password,
            firstName: this.firstName,
            lastName: this.lastName,
            permissions: this.permissions.filter((p) => p.selected),
        };
        this.$emit('create-user-saved', user);
    }
    public reset(): void {
        this.selectedTab = 0;
        this.email = null;
        this.password = null;
        this.firstName = null;
        this.lastName = null;
        this.permissions = new Array<{ id: string, name: string, selected: boolean }>(...[
            { id: 'A8DEC754-9A53-4037-BA03-EBC3B3FC1951', name: 'Create enquiries', selected: false },
            { id: '06E41F0C-6058-469D-B53E-8710AC5B7C77', name: 'View enquiries', selected: false },
            { id: '2548CA69-D42C-4B2A-8FDB-6906E79F3B11', name: 'Create orders', selected: false },
            { id: '46BEFEAE-387E-4F1E-A2B3-6034DF1286EB', name: 'View orders', selected: false },
            { id: '2E5E95A6-361E-4BBF-968C-C766AB782EE8', name: 'Create quotes', selected: false },
            { id: '8A3A0700-01BD-4788-B1BB-D3ED58F79C95', name: 'View quotes', selected: false },
            { id: '312B9FEB-F26F-40F7-BF93-34C664AAE57A', name: 'View Approvals', selected: false },
            { id: 'A8AB1446-1848-48E7-9E7F-DBAA01BD6A90', name: 'Approve up to £1,000', selected: false },
            { id: '2F6F468D-F5E3-43DB-8897-F4FE747A4A30', name: 'Approve from £1,000 to £5,000', selected: false },
            { id: 'E003B0BE-FD26-452A-BF0F-A071608F5831', name: 'Approve from £5,000 to £10,000', selected: false },
            { id: 'DD0B632E-B592-49D5-AEBC-0BF222E061FE', name: 'Approve from £10,000', selected: false },
            { id: '92AC7CB6-D61A-4FA7-AE27-31178D31B8EB', name: 'Administrator', selected: false }
        ]);
    }
    public toggleShow(): void {
        if (this.showing) {
            this.$emit('create-user-show');
        } else {
            this.$emit('create-user-hide');
        }
    }
    @Watch('show')
    public toggle(value: boolean): void {
        this.reset();
        this.showing = value;
    }
}
